// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"checkboxes-mobile-styles_checkboxes__2KbCL"};